// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 兼容ie
import 'babel-polyfill';


import Vue from 'vue';
import App from './App';
import router from "./router";
import axios from 'axios';
import dev from '../config/dev.env.js'
// Vue.use(layer);
import Video from 'video.js'
import VueCanvasPoster from 'vue-canvas-poster'
Vue.use(VueCanvasPoster)
import wx from 'weixin-js-sdk';
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'
Vue.prototype.$video = Video;
Vue.prototype.$wx = wx;

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)


// 使用 vue-meta
import Meta from "vue-meta";
Vue.use(Meta);
import visibility from 'vue-visibility-change';
Vue.use(visibility);
visibility.change((evt, hidden) => {

});

//css
import '@/assets/css/reset.css';
import '@/assets/css/layer.css';
//公用js
import '@/assets/js/layer.js';
import common from '@/assets/js/common';
Vue.use(common);

//请求封装
import { post, get, fileUpload } from '@/assets/sriper/request.js'

//插件
import ElementUI from 'element-ui';
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
import Vuex from 'vuex'
Vue.use(Vuex)
import store from './store/store'

import VEmojiPicker from 'v-emoji-picker';
Vue.use(VEmojiPicker);


//定义全局变量
Vue.prototype.$ajax = axios;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$fileUpload = fileUpload;

Vue.prototype.$URL = dev.URL;
Vue.prototype.$IMG_URL = dev.IMG_URL;
Vue.prototype.$LIVE_URL = dev.LIVE_URL;
Vue.prototype.$IM_URL = dev.IM_URL;
Vue.prototype.$VIEW_URL = dev.VIEW_URL;
Vue.prototype.isshowimg = function(imgs) {
    let url = "http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/headimage/moren.jpg"
    return imgs ? imgs : url

}


Vue.config.productionTip = false;


//加入百度统计
router.beforeEach((to, from, next) => {
    if (to.path) {
        if (window._hmt) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }
    next()
})



/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App, axios },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js